<app-holidays-card *ngFor="let holiday of holidays" [holiday]="holiday"></app-holidays-card>
 
